import { ISitemapTag } from './reader-sitemap.js';

export const writerSiteMap: ISitemapTag[] = [
  {
    customUrl: '/',
    title:
      'Nền tảng đọc và viết truyện Awread - nơi bạn viết để chữa lành',
    description: `Awread giúp tác giả xây dựng cửa hàng và tiếp cận tới hàng triệu độc giả`,
    image: 'https://awread.com/frontend-assets/banners/writer-banner-home.webp',
  },
];
